import { render, staticRenderFns } from "./lengOrder.vue?vue&type=template&id=3188283a"
import script from "./lengOrder.vue?vue&type=script&lang=js"
export * from "./lengOrder.vue?vue&type=script&lang=js"
import style0 from "./lengOrder.vue?vue&type=style&index=0&id=3188283a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports